import {Injectable} from "@angular/core";
import {UpgradeModule} from "@angular/upgrade/static";

@Injectable({
    providedIn: "root",
})
export class RootScopeService {
    rootScope;

    constructor(private upgrade: UpgradeModule) {
        this.rootScope = upgrade.injector.get("$rootScope");
    }

    public onChangeStart(cb: Function): any {
        return this.rootScope.$on('$stateChangeStart', cb);
    }

    public onChangeSuccess(cb: Function): any {
        return this.rootScope.$on('$stateChangeSuccess', cb);
    }
}
